import { useState } from 'react';
import { Button, Group, Modal, Table, Text, TextInput } from '@mantine/core';

const MergeTagsModal = ({ mergeTags, close, show }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredTags = mergeTags.filter(
    (tag) =>
      tag.pattern.toLowerCase().includes(searchTerm.toLowerCase()) ||
      tag.label.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleClose = () => {
    setSearchTerm('');
    close();
  };

  return (
    <Modal size="lg" opened={show} onClose={handleClose} title="Available Merge Tags">
      <TextInput
        placeholder="Search merge tags..."
        value={searchTerm}
        onChange={handleSearchChange}
        autoFocus
        mb="md"
      />
      <Table striped withTableBorder highlightOnHover>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Pattern</Table.Th>
            <Table.Th>Label</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {filteredTags.length > 0 ? (
            filteredTags.map((tag) => (
              <Table.Tr key={tag.key}>
                <Table.Td>{tag.pattern}</Table.Td>
                <Table.Td>{tag.label}</Table.Td>
              </Table.Tr>
            ))
          ) : (
            <Table.Tr>
              <Table.Td colSpan={2}>
                <Text ta="center" c="dimmed">
                  No merge tags found matching "{searchTerm}"
                </Text>
              </Table.Td>
            </Table.Tr>
          )}
        </Table.Tbody>
      </Table>
      <Group justify="flex-end" mt="md">
        <Button variant="default" onClick={handleClose}>
          Close
        </Button>
      </Group>
    </Modal>
  );
};

export default MergeTagsModal;
